const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新不遗漏',
    desc: '每日大赛吃瓜入口保持高频更新节奏，最新视频、独家爆料与系列内容第一时间上线，让你永远走在吃瓜第一线。覆盖全网主流大赛的最新动态，从选秀到电竞，一站看全。',
  },
  {
    icon: 'ri-stack-line',
    title: '系列内容深度追踪',
    desc: '从赛事预告到赛后复盘，从选手故事到行业观察，大赛吃瓜在线提供完整的系列追踪报道。每档大赛均有专属合集，不错过任何一期关键进展与名场面回顾。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '来源核实放心吃瓜',
    desc: '所有大赛吃瓜内容均经过多方交叉核实，标注信息来源与可信度评估。拒绝无根据的谣言与虚假爆料，为吃瓜群众提供可靠、有据可查的大赛娱乐资讯。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div key={i} className="text-center">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}